'use client';

import { motion } from 'framer-motion';
import { fadeIn, staggerContainer } from '@/lib/animations';
import { ArrowRight, ShieldCheck } from 'lucide-react';
import { Button } from './components/ui/button';

export function FoodGradeHero() {
	return (
		<section className="relative min-h-screen flex items-center pt-16 overflow-hidden">
			{/* Background with overlay */}
			<div className="absolute inset-0 z-0">
				<div className="bg-primary-900 absolute top-0 left-0 w-screen h-full z-10 opacity-70" />
				<img
					src="https://lindner-marketing.s3.eu-west-2.amazonaws.com/different-legumes-in-glass-jars-chickpeas-pasta-2023-11-27-05-32-11-utc-2.webp"
					alt="Food grade warehouse facility"
					className="w-full h-full object-cover"
				/>
			</div>

			<div className="container mx-auto px-4 md:px-6 relative z-20 py-24 md:py-32">
				<motion.div
					variants={staggerContainer}
					initial="hidden"
					animate="show"
					viewport={{ once: true, amount: 0.1 }}
					className="max-w-4xl"
				>
					<motion.div variants={fadeIn('up', 0.2)}>
						<Button className="mb-8 bg-white text-brand-600 hover:bg-gray-100 rounded-full px-4 py-2 font-medium flex items-center gap-2">
							<ShieldCheck size={16} />
							FDA & USDA Compliant
						</Button>
					</motion.div>

					<motion.h1
						variants={fadeIn('up', 0.3)}
						className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6"
					>
						Certified Food Grade Warehouse Solutions
					</motion.h1>

					<motion.p
						variants={fadeIn('up', 0.4)}
						className="text-xl md:text-2xl text-gray-100 mb-8 max-w-3xl leading-relaxed"
					>
						When it comes to storing food products, compliance and cleanliness are
						non-negotiable. Our certified food grade warehouse provides the highest
						standards in safety, sanitation, and efficiency.
					</motion.p>

					<motion.div variants={fadeIn('up', 0.5)} className="flex justify-start">
						<Button
							asChild
							className="bg-brand-600 hover:bg-brand-700 text-white px-8 py-6 text-lg"
						>
							<a href="#contact">Get Started</a>
						</Button>
					</motion.div>
				</motion.div>
			</div>

			{/* Wave decoration */}
			<div className="absolute bottom-0 left-0 right-0">
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 120" className="w-full">
					<path
						fill="#ffffff"
						fillOpacity="1"
						d="M0,96L80,85.3C160,75,320,53,480,53.3C640,53,800,75,960,80C1120,85,1280,75,1360,69.3L1440,64L1440,120L1360,120C1280,120,1120,120,960,120C800,120,640,120,480,120C320,120,160,120,80,120L0,120Z"
					></path>
				</svg>
			</div>
		</section>
	);
}
